<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> 
            
            {{ bRentDetail ? 'جزئیات اجاره' : 'عملکرد به تفکیک تاریخ' }}
        
        </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-3 position-relative">

            <label> از تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-3 position-relative">

            <label> تا تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Report()"> &nbsp; جستجو &nbsp; </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')"> خروجی اکسل </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-2 mt-md-3 p-2" >

        <ng-container *ngIf="bRentDetail">

            <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

        </ng-container>

        <div class="section border border-2 mt-1 mt-md-2" [ngClass]="bRentDetail ? 'section-detail' : 'section-byDate' ">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <!-- عملکرد به تفکیک تاریخ -->

                    <ng-container *ngIf="!this.bRentDetail;else isRentDetail">

                        <tr class="">
        
                            <th class="text-center col-1"> # </th>
        
                            <th class="text-center"> تاریخ </th>
    
                            <th class="text-center"> روز </th>
    
                            <th class="text-center"> تعداد کل اسکوتر </th>
    
                            <th class="text-center"> تعداد اجاره </th>
    
                            <th class="text-center"> مدت کل اجاره </th>
    
                            <th class="text-center"> مبلغ کل اجاره (ریال) </th>
    
                            <th class="text-center"> مبلغ خسارت (ریال) </th>
    
                            <th class="text-center"> مبلغ کل (ریال) </th>
            
                        </tr>

                    </ng-container>

                    <!-- جزئیات اجاره -->

                    <ng-template #isRentDetail>

                        <tr class="">
        
                            <th class="text-center col-1"> # </th>

                            <th class="text-center col-1"> عملیات </th>

                            <th class="text-center"> تاریخ </th>
    
                            <th class="text-center"> نام دستگاه </th>
    
                            <th class="text-center"> شروع </th>
    
                            <th class="text-center"> پایان </th>
    
                            <th class="text-center"> مدت  </th>
    
                            <th class="text-center"> مبلغ (ریال) </th>
    
                            <th class="text-center"> پیمایش </th>
    
                            <th class="text-center"> مشتری </th>

                            <th class="text-center"> موبایل </th>

                            <th class="text-center"> خسارت </th>

                            <th class="text-center"> مبلغ خسارت (ریال) </th>
            
                        </tr>

                    </ng-template>
                    
                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <!-- عملکرد به تفکیک تاریخ -->

                        <ng-container *ngIf="!bRentDetail;else isRentalRow">

                            <th> {{ i + 1 | faNum }} </th>

                            <td> {{ item.strRent_Date | faNum }} </td>
    
                            <td> {{ item.strDayName.trim() | faNum }} </td>
    
                            <td> {{ item.iDeviceCount | faNum }} </td>
    
                            <td> {{ item.iRentCount | faNum }} </td>
    
                            <td> {{ item.strRentTime | faNum }} </td>
    
                            <td> {{ item.iCost.toLocaleString() | faNum }} </td>
    
                            <td> {{ item.iDamageCost.toLocaleString() | faNum }} </td>
    
                            <td> {{ item.iTotalCost.toLocaleString() | faNum }} </td>

                        </ng-container>

                        <!-- جزئیات اجاره -->

                        <ng-template #isRentalRow>

                            <th> {{ i + 1 | faNum }} </th>

                            <td class="operation-icons"> 

                                <i class="fa fa-info-circle fa-lg pointer" (click)="openInfo(item)"></i>
                                
                            </td>

                            <td> {{ item.strRent_Date | faNum }} </td>

                            <td> {{ item.strMobile_strFullName | faNum }} </td>

                            <td> {{ item.strRent_Date | faNum }} </td>

                            <td> {{ item.strReturn_Date | faNum }} </td>

                            <td> {{ item.strRentTime | faNum }} </td>
    
                            <td> {{ item.iTotalCost.toLocaleString() | faNum }} </td>

                            <td> {{ item.fKm.toLocaleString() + ' کیلومتر ' | faNum }} </td>

                            <td> {{ item.strFullName | faNum }} </td>

                            <td> {{ item.strMobile | faNum }} </td>

                            <td> {{ item.bDamage  ? '✅' : '❌' }} </td>

                            <td> {{ item.iDamageCost.toLocaleString() | faNum }} </td>
    
                        </ng-template>

                    </tr>

                </tbody>

            </table>

        </div>

        <!-- سرجمع -->

        <div class="bg-th-blue w-100 p-2">

            <!-- عملکرد به تفکیک تاریخ -->

            <ng-container *ngIf="!bRentDetail;else isRentalTotal">
                
                <div class="row gx-2 gy-2">

                    <!--  تعداد کل اجاره -->

                    <div class="col-6 col-md-1">

                        <span class="fw-bold"> کل اجاره : {{ obj_Report.iRentCount | faNum }} </span>

                    </div>

                    <!-- سرجمع مدت اجاره -->

                    <div class="col-6 col-md-2">

                        <span class="fw-bold">  مدت اجاره : {{ format_Time(obj_Report.strRentTime) | faNum }} </span>

                    </div>

                    <!-- سرجمع مبلغ اجاره -->

                    <div class="col-6 col-md-3">

                        <span class="fw-bold">  مبلغ اجاره : {{ obj_Report.iCost.toLocaleString() | faNum }} </span>

                    </div>

                    <!-- سرجمع مبلغ خسارت -->

                    <div class="col-6 col-md-3">

                        <span class="fw-bold">  مبلغ خسارت : {{ obj_Report.iDamageCost.toLocaleString() | faNum }} </span>

                    </div>

                    <!-- سرجمع مبلغ کل -->

                    <div class="col-6 col-md-2">

                        <span class="fw-bold">  مبلغ کل : {{ obj_Report.iTotalCost.toLocaleString() | faNum }} </span>

                    </div>

                </div>

            </ng-container>

            <!-- جزئیات اجاره -->

            <ng-template #isRentalTotal>

                <div class="row gx-2 gy-2">

                    <!-- تعداد کل -->

                    <div class="col-6 col-md-2">

                        <span class="fw-bold">  
                            
                            تعداد کل : {{ lst_Report.length | faNum }} 
                        
                        </span>

                    </div>

                    <!-- سرجمع مدت اجاره -->

                    <div class="col-6 col-md-2">

                        <span class="fw-bold">  مدت اجاره : {{ format_Time(obj_Report.strRentTime) | faNum }} </span>

                    </div>

                    <!-- پیمایش -->

                    <div class="col-6 col-md-2">

                        <span class="fw-bold">  
                            
                            پیمایش : {{ obj_Report.fKm.toFixed(2) | faNum }}
                        
                        </span>

                    </div>

                    <!-- سرجمع مبلغ خسارت -->

                    <div class="col-6 col-md-3">

                        <span class="fw-bold">  مبلغ خسارت : {{ obj_Report.iDamageCost.toLocaleString() | faNum }} </span>

                    </div>

                    <!-- سرجمع مبلغ کل -->

                    <div class="col-6 col-md-2">

                        <span class="fw-bold">  مبلغ کل : {{ obj_Report.iTotalCost.toLocaleString() | faNum }} </span>

                    </div>

                </div>

            </ng-template>

        </div>

    </div>

</main>


<!-- جزئیات اجاره -->

<div class="modal fade" id="RentInfo_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> جزئیات اجاره </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="container-fluid row gx-2 gy-2 p-2">

                    <!-- شماره اجاره -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> شماره اجاره </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.iRent | faNum" disabled>
            
                    </div>

                    <!-- نام و نام‌خانوادگی -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> نام و نام&zwnj;خانوادگی </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strFullName | faNum" disabled>
            
                    </div>

                    <!-- موبایل -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> موبایل </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strMobile | faNum" disabled>
            
                    </div>

                    <!-- کد ملی -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> کد ملی </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strID | faNum" disabled>
            
                    </div>

                    <!-- نوع وثیقه -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> نوع وثیقه </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strRent_CollateralType_strComment | faNum" disabled>
            
                    </div>

                    <!-- تاریخ اجاره  -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تاریخ اجاره  </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strRent_Date | faNum" disabled>
            
                    </div>

                    <!-- ساعت اجاره  -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> ساعت اجاره  </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strRent_Time | faNum" disabled>
            
                    </div>

                    <!-- تاریخ پایان  -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> تاریخ پایان  </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strReturn_Date | faNum" disabled>
            
                    </div>

                    <!-- ساعت پایان  -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> ساعت پایان  </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strReturn_Time | faNum" disabled>
            
                    </div>
                                        
                    <!-- مدت اجاره تا کنون -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> مدت اجاره تا کنون </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.strRentTime | faNum" disabled>
            
                    </div>
                    
                    <!-- هزینه اجاره -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> هزینه اجاره </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.iCost?.toLocaleString() + ' ریال ' | faNum" disabled>
            
                    </div>
                    
                    <!-- هزینه خسارت -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> هزینه خسارت </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.iDamageCost?.toLocaleString() + ' ریال ' | faNum" disabled>
            
                    </div>
                    
                    <!-- پیمایش -->

                    <div class="position-relative col-12 col-md-4 p-2">
            
                        <label class="mb-2 text-muted"> پیمایش </label>
            
                        <input class="form-control p-2 text-center" [value]="obj_RentAnalysis.fKm + ' کیلومتر ' | faNum" disabled>
            
                    </div>
                    
                    <!-- توضیحات -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> توضیحات </label>

                        <textarea style="height: 100px;resize: none;"

                            [value]="obj_RentAnalysis.strComment | faNum"
                        
                            class="form-control">
                        
                        </textarea>

                    </div>
                                        
                    <!-- تخلف خروج غیر مجاز -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bDamage"  [(ngModel)]="obj_RentAnalysis.bOutofDomainError">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bDamage"> دستگاه تخلف خروج غیر مجاز داشته است </label>
                    
                    </div>

                    <!-- تصادف -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bDamage" [(ngModel)]="obj_RentAnalysis.bAccident">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bDamage"> دستگاه تصادف کرده است </label>
                    
                    </div>

                    <!-- خسارت -->

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bDamage" [(ngModel)]="obj_RentAnalysis.bDamage">
                    
                        <label class="form-check-label pointer text-muted me-2" for="bDamage"> دستگاه خسارت دیده است </label>
                    
                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary px-3" (click)="showRoute(obj_RentAnalysis)">

                    &nbsp; مسیر &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>